import { GraduationCap } from 'lucide-react';
import { PhaseStubPage } from '@/components/layout/PhaseStubPage';

export function TrainingPage() {
  return (
    <PhaseStubPage
      title="Training records"
      phase={5}
      modules={[
        'Per-user training matrix view',
        'Auto-assign new versions to required readers',
        'Due-date reminders + escalation',
        'Acknowledgement audit trail (timestamp + IP)',
      ]}
      icon={GraduationCap}
    />
  );
}
